import { useQuery } from 'react-query';

import { useApi } from '@/lib/api';
import { computeGeometryAreaIdOrStageId } from '@/lib/api/queries/utils';
import { useLocale } from '@/lib/contexts';

import { ActivityReportDetailsProps } from '../activity-report/types';

export function useArPriceChangesTable({
  workspaceId,
  activeDatasets,
  filters,
  geometry,
  areaId,
  period,
  lastPeriodIncludes,
}: ActivityReportDetailsProps) {
  const { api } = useApi();
  const { locale } = useLocale();

  return useQuery(
    [
      'activity-reports-price-changes-table',
      workspaceId,
      geometry,
      filters,
      areaId,
      locale,
      period,
      lastPeriodIncludes,
    ],
    async () =>
      typeof workspaceId === 'string'
        ? api.geodata.chartSources.activityReportsPriceChangesTable(
            workspaceId,
            {
              include_dataset: activeDatasets,
              ...filters,
              ...computeGeometryAreaIdOrStageId(geometry, areaId),
              period: period,
              last_period_includes: lastPeriodIncludes,
            }
          )
        : undefined,
    {
      enabled:
        !!workspaceId &&
        !!period &&
        !!activeDatasets &&
        !!computeGeometryAreaIdOrStageId(geometry, areaId),
      //These are mandatory params by the endpoint
    }
  );
}
